import Admin_Dashboard from "../components/Dashboard/Admin_Dashboard/Admin_Dashboard";
import Reports from "../components/reports/Reports";
import ReportView from "../components/reports/ReportView";
export default [
  {
    path: "",
    element: <Admin_Dashboard />,
  },
  {
    path: "reports",
    element: <Reports />,
  },
  {
    path: "reportView/:reportId",
    element: <ReportView />,
  },
];
